import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Table,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from "@chakra-ui/react";
import React, { useState } from "react";


export default function RouteHistoryModal({
    isRouteHistoryOpen,
    onCloseRouteHistory,
    selectedRoute,
    routeGenerationHistory,
}) {
    const [openRow, setOpenRow] = useState(null);

    return (
        <Modal
            isOpen={isRouteHistoryOpen}
            scrollBehavior="inside"
            onClose={onCloseRouteHistory}
            size="5xl"
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    Route Generation History: {selectedRoute?.name}
                </ModalHeader>
                <ModalBody>
                    <Table size="sm">
                        <Thead>
                            <Tr>
                                <Th>Date</Th>
                                <Th>Generated By</Th>
                                <Th>Pickups Count</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {routeGenerationHistory.map((history) => (
                                <React.Fragment key={history._id}>
                                    <Tr
                                        onClick={() =>
                                            setOpenRow(openRow === history._id ? null : history._id)
                                        }
                                        cursor="pointer"
                                    >
                                        <Td>
                                            {new Date(history.generatedAt).toLocaleDateString()}
                                        </Td>
                                        <Td>{history.generatedBy?.firstName}</Td>
                                        <Td>{history.details?.length}</Td>
                                    </Tr>

                                    {openRow === history._id && (
                                        <Tr>
                                            <Td colSpan={3}>
                                                <Table size="sm" variant="simple">
                                                    <Thead>
                                                        <Tr>
                                                            <Th>From</Th>
                                                            <Th>To</Th>
                                                            <Th>Courier</Th>
                                                            <Th>Type</Th>
                                                            <Th>Order</Th>
                                                        </Tr>
                                                    </Thead>
                                                    <Tbody>
                                                        {history.details?.map((d, i) => (
                                                            <Tr key={i}>
                                                                <Td>{d.from?.name}</Td>
                                                                <Td>{d.to?.name}</Td>
                                                                <Td>{d.courier?.name}</Td>
                                                                <Td>{d.type}</Td>
                                                                <Td>{d.order}</Td>
                                                            </Tr>
                                                        ))}
                                                    </Tbody>
                                                </Table>
                                            </Td>
                                        </Tr>
                                    )}
                                </React.Fragment>
                            ))}
                        </Tbody>
                    </Table>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={onCloseRouteHistory}>Close</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
